import { ru as ru$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var ru = {
  language: 'ru',
  country: 'ru',
  name: 'Русский',
  embeddedLocale: merge(error, login),
  flags: ['RU'],
  dateFns: ru$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { ru as default };
